export default __webpack_public_path__ + "static/media/WWN.0ecec6e5.jpg";